import { render, staticRenderFns } from "./InfoAnimatoren.vue?vue&type=template&id=56480889"
import script from "./InfoAnimatoren.vue?vue&type=script&lang=js"
export * from "./InfoAnimatoren.vue?vue&type=script&lang=js"
import style0 from "./InfoAnimatoren.vue?vue&type=style&index=0&id=56480889&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports